export default "__VITE_ASSET__BPYAQ4TR__"